module.exports = __webpack_public_path__ + "img/living-room-7939062_1280.0d1947b1.png";